import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>404 Page Not Found | Square Trigger</title>
        <meta
          name="description"
          content="The page you are looking for could not be found on Square Trigger."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <main
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "120px 20px",
          textAlign: "center",
          background:
            "linear-gradient(135deg, #f8f7ff 0%, #ffffff 45%, #f3f0ff 100%)",
        }}
      >
        <section
          style={{
            maxWidth: "620px",
            width: "100%",
            padding: "48px 28px",
            borderRadius: "28px",
            background: "rgba(255, 255, 255, 0.85)",
            boxShadow: "0 24px 70px rgba(35, 20, 90, 0.12)",
            border: "1px solid rgba(120, 92, 255, 0.16)",
          }}
        >
          <p
            style={{
              margin: "0 0 12px",
              fontSize: "15px",
              fontWeight: "700",
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: "#7c3aed",
            }}
          >
            Error 404
          </p>

          <h1
            style={{
              margin: "0 0 16px",
              fontSize: "clamp(34px, 5vw, 58px)",
              lineHeight: "1.05",
              color: "#120b2f",
              fontWeight: "800",
            }}
          >
            Page Not Found
          </h1>

          <p
            style={{
              margin: "0 auto 28px",
              maxWidth: "480px",
              fontSize: "18px",
              lineHeight: "1.7",
              color: "#4b4663",
            }}
          >
            The page you are looking for does not exist or may have been moved.
          </p>

          <Link
            to="/"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "14px 24px",
              borderRadius: "999px",
              background: "linear-gradient(135deg, #7c3aed, #a855f7)",
              color: "#ffffff",
              fontSize: "15px",
              fontWeight: "700",
              textDecoration: "none",
              boxShadow: "0 14px 34px rgba(124, 58, 237, 0.28)",
            }}
          >
            Go Back Home
          </Link>
        </section>
      </main>
    </>
  );
}

export default NotFoundPage;